export enum FunkrundsteuerEmpfaengerAbregelmoeglichkeit {
    KEINE = 'KEINE',
    FIX70 = 'FIX70',
    FRE = 'FRE',
    FWA = 'FWA',
    TASE2 = 'TASE2',
    IEC101_104 = 'IEC101_104',
    FALLBACK_PROCESS_BY_PHONE = 'FALLBACK_PROCESS_BY_PHONE',
}

export class FunkrundsteuerEmpfaengerAbregelmoeglichkeitItem {

    public key: FunkrundsteuerEmpfaengerAbregelmoeglichkeit;
    public description: string;

    constructor(key: FunkrundsteuerEmpfaengerAbregelmoeglichkeit, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): FunkrundsteuerEmpfaengerAbregelmoeglichkeitItem[] {
        return [
            new FunkrundsteuerEmpfaengerAbregelmoeglichkeitItem(
                FunkrundsteuerEmpfaengerAbregelmoeglichkeit.KEINE,
                'Keine Regelung möglich',
            ),
            new FunkrundsteuerEmpfaengerAbregelmoeglichkeitItem(
                FunkrundsteuerEmpfaengerAbregelmoeglichkeit.FIX70,
                '70%',
            ),
            new FunkrundsteuerEmpfaengerAbregelmoeglichkeitItem(
                FunkrundsteuerEmpfaengerAbregelmoeglichkeit.FRE,
                'FRE',
            ),
            new FunkrundsteuerEmpfaengerAbregelmoeglichkeitItem(
                FunkrundsteuerEmpfaengerAbregelmoeglichkeit.FWA,
                'FWA',
            ),
            new FunkrundsteuerEmpfaengerAbregelmoeglichkeitItem(
                FunkrundsteuerEmpfaengerAbregelmoeglichkeit.TASE2,
                'Leitstellenkopplung TASE.2',
            ),
            new FunkrundsteuerEmpfaengerAbregelmoeglichkeitItem(
                FunkrundsteuerEmpfaengerAbregelmoeglichkeit.IEC101_104,
                'Leitstellenkopplung IEC..101/104',
            ),
            new FunkrundsteuerEmpfaengerAbregelmoeglichkeitItem(
                FunkrundsteuerEmpfaengerAbregelmoeglichkeit.FALLBACK_PROCESS_BY_PHONE,
                'Telefonischer Rückfallprozess',
            ),
        ];
    }
}
